/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
exports.onClientEntry = () => {
  if (process.env.NODE_ENV === 'development') return

  if (process.env.GATSBY_SENTRY_DSN) {
    require.ensure(['raven-js'], function (require) {
      const Raven = require('raven-js')

      if (!Raven.isSetup()) {
        const config = { environment: process.env.NODE_ENV }
        Raven.config(process.env.GATSBY_SENTRY_DSN, config).install()
      }
      window.Raven = Raven
    })
  }
}



// WEBPACK FOOTER //
// ./gatsby-browser.js